<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
        :model="formData"
        ref="ruleForm"
        :rules="rules"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-divider>赛后资料上传</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="成绩册"
              prop="chengjice" 
              :rules="[
                { required: true, message: '请选择', trigger: 'blur' },
              ]"
            >
              <FileUploader uploadText="上传文件" :fileList="formData.chengjice" :limit="1" accept=".doc,.pdf,.docx"
                                  :name="'chengjice'"></FileUploader>
            </el-form-item>
            
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="总结"
              prop="zongjie" 
              :rules="[
                { required: true, message: '请选择', trigger: 'blur' },
              ]"
            >
              <FileUploader uploadText="上传文件" :fileList="formData.zongjie" :limit="2" accept=".doc,.pdf,.docx"
                                  :name="'zongjie'"></FileUploader>
            </el-form-item>
             
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="请输入调查表链接"
              prop="diaochabiao"
            >
              <el-input
                type="text"
                placeholder="请输入调查表链接"
                v-model="formData.diaochabiao"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
 
        <el-row>
          <el-col class="footer-button">
            <el-button
              type="primary"
              @click="submitForm('ruleForm')"
              :loading="saveLoading"
              >提交
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>

      <LoginDialog
        :show="loginShow"
        @loginSuccess="loginSuccess"
        @loginCancel="loginCancel"
      />
    </div>
  </div>
</template>
<style scoped>
.box {
  width: 100%;
  margin: 0 auto;
}
.form {
  width: 1340px;
  min-height: 560px;
  background: #ffffff;
  padding-top: 24px;
  padding: 88px 0 30px 129px;
  box-sizing: border-box;
}
.savebtn {
  margin-top: 40px;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
</style>
<script>
import Vue from "vue";
import validator from "../../../utils/validator";
import FileUploader from '@/components/picker/FileUploader.vue';
import PicUploader from "@/components/picker/PicUploader.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Dialog,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";
import CaipanPicker from "@/components/picker/CaipanPicker.vue";
import JiaolianPicker from "@/components/picker/JiaolianPicker.vue";
import LoginDialog from "@/components/LoginDialog.vue"; 
// import UEditor from "@/components/UEditor/";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Dialog)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "HuiyiApplyFormStep1",
  components: {
    [Field.name]: Field,
    PicUploader,
    CaipanPicker,
    JiaolianPicker,
    LoginDialog,
    FileUploader,
    // UEditor,
  },
  data: function () {
    return {
      validator,
      arr: [],
      areaOptions: [],
      loginShow: false,
      saveLoading: false,
      saiqu_id: this.$route.query.saiqu_id,
      numTypeColumns: ["身份证", "护照"],
      showArea: false,
      areaList: {},
      areaValue: "",
      clockSecond:0,
      submitType: "",
      formData: {
        id: 0, 
        chengjice:[],
        diaochabiao:'',
        zongjie:[],
      },
      rules: { 
      },
    };
  },
  filters: {},
  mounted() {
    let that = this;
    that.formData.id = this.$route.query.id;
    document.title = "赛后资料上传";
    if(that.formData.id){
      this.fetch();
    }
    this.getAreaOptions();
  },
  watch: {
    formData() {},
  },
  destroyed() {},
  methods: {
    getCode() {
        let that = this;
        if (that.clockSecond > 0) {
            return;
        }
        if (!that.formData.phone) {
            Toast('请输入手机号')
            return;
        }
        /*if (!that.formData.code) {
            Toast('请输入验证码')
            return;
        }*/
        that.$api.get('/api/index/phonecode', {phone: that.formData.phone}, (res) => {
            Toast(res.msg);
        })

        that.clockSecond = 60;

        var t = setInterval(function () {
            if (that.clockSecond > 0) {
                that.clockSecond = that.clockSecond - 1;
            } else {
                clearInterval(t);
            }
        }, 1000)
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleChange(val) {
      console.log(val);
      for (var i = 0; i < this.arr.length; i++) {
        if (this.arr[i].value == val[0]) {
          this.formData.city = this.arr[i].title;
        }
        if (this.arr[i].value == val[1]) {
          this.formData.county = this.arr[i].title;
        }
        if (this.arr[i].value == val[2]) {
          this.formData.province = this.arr[i].title;
        }
      }
      this.formData.area = val[2];
    },
    getAreaOptions() {
      let that = this;
      that.$api.post("/api/utils/areaTree", {}, (res) => {
        that.areaOptions = res.data;
        that.namekeyList = res.data;
      });
    },
    handleAreasChange(values) {
      let data = this.$refs.areas.getCheckedNodes()[0].pathLabels;
      console.log("handleAreasChange", values, data);
      this.formData.area = values[2];
      this.formData.province = data[0];
      this.formData.city = data[1];
      this.formData.county = data[2];
    }, 
    fetch() {
      let that = this;
      that.$api.get(
        "/api/cpz/applyDetail",
        { 
          id: that.formData.id,
        },
        (res) => { 
          that.formData = Object.assign(that.formData, res.data);

          console.log("Dialog"); 
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onQuestion() {
      console.log("onQuestion");
    },
    jumToOld(id) {
      rbLink(
        {
          name: "HuiyiApplyList",
        },
        "replace"
      );
    },

    submitForm(formName) {
      const that = this;
      // 拿到地区的 省市区名称
      // that.formData["area"] = that.formData.areas[2];

      console.log(that.formData, that.$refs[formName]);
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          console.log(that.formData);
          that.formValidate = true; 
          that.saveLoading = true;
          that.$api.post(
            "/api/cpz/upload",
            that.formData,
            (res) => {
              that.saveLoading = false;
               that.$message.success('提交成功')
               rbLink(
                {
                  name: "CpzApplyList",
                },'back')
            },
            (res) => {
              this.$message.warning(res.msg);
              that.saveLoading = false;
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    submit(values) {
      this.submitType = "submit";
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// CpzApplyFormStep2.vue?a7019a8e